import axios from 'axios';
import { exportXls } from "utils";
import { getPendingCharges, getPendingSolicitation } from "services/company-service";
import { getChargeLinesIN } from "services/solicitation-service";
import { getAllEmployee } from "services/employee-service"
import lodash from "lodash";
import { translate } from 'config/language';

export const pendingCharges = ({
    load: async () => {
        const res = await getPendingCharges();
        if (res) {
            return {
                title: "Cobranças Abertas",
                subtitle: "Estes são os valores que estão em aberto do custo por participante.",
                fee: res.reduce((x, y) => x + y.value, 0),
                columns: [
                    {
                        align: "center",
                        title: "Data",
                        key: "createdAt",
                        dataIndex: "createdAt",
                        details: {
                            type: "date",
                            format: "DD/MM/YYYY"
                        }
                    },
                    {
                        align: "center",
                        title: "Mês Referência",
                        key: "month",
                        dataIndex: "month",
                        details: {
                            type: "date",
                            format: "MM/YYYY"
                        }
                    },
                    {
                        title: "Empresa",
                        key: "company.name",
                        dataIndex: ["company", "name"],
                    },
                    {
                        align: "right",
                        title: "Valor Total",
                        key: "value",
                        dataIndex: "value",
                        details: {
                            type: "money"
                        }
                    },
                    {
                        align: "right",
                        title: "Valor Unitário",
                        key: "unitaryValue",
                        dataIndex: "unitaryValue",
                        details: {
                            type: "money"
                        }
                    },
                    {
                        align: "right",
                        title: "Quantidade",
                        key: "quantity",
                        dataIndex: "quantity",
                    },
                    {
                        align: "center",
                        title: "Status",
                        key: "status.name",
                        dataIndex: ["status", "name"],
                    },
                ],
                data: res
            };
        }
        return null;
    }
})

export const pendingSolicitation = ({
    load: async (company) => {
        const res = await getPendingSolicitation(company);
        if (res) {
            return {
                title: "Desconto Disponível",
                subtitle: `Estes são os pedidos que estão em aberto e utilizam ${translate('balance')} da empresa.`,
                columns: [
                    {
                        align: "center",
                        title: "Data",
                        key: "createdAt",
                        dataIndex: "createdAt",
                        details: {
                            type: "date",
                            format: "DD/MM/YYYY"
                        }
                    },
                    {
                        align: "center",
                        title: "Tipo",
                        key: "type.name",
                        dataIndex: ["type", "name"],
                    },
                    {
                        align: "right",
                        title: "Valor",
                        key: "value",
                        dataIndex: "value",
                        details: {
                            type: "money"
                        }
                    },
                    {
                        align: "right",
                        title: "Desconto Usado",
                        key: "discount",
                        dataIndex: "discount",
                        details: {
                            type: "money"
                        }
                    },
                    {
                        align: "center",
                        title: "Status",
                        key: "status.name",
                        dataIndex: ["status", "name"],
                    },
                ],
                data: res
            };
        }
        return null;
    }
})

export const consolidatedReport = async (solicitations) => {
    const xlsxSolicitation = solicitations.map(solicitation => {
        return ({
            "Pedido": solicitation.id,
            "Empresa": solicitation.company.name,
            "CNPJ": solicitation.company.cnpj,
            "Tipo": solicitation.type.name,
            "Valor do Pedido": solicitation.value,
            "Valor a Pagar": solicitation.netValue,
            "Desconto": solicitation.discount,
            "Taxa": solicitation.fee,
            "Status": solicitation.status.name,
            "Data de Pagamento": solicitation.payment && solicitation.payment.paidAt ? new Date(solicitation.payment.paidAt) : null,
            "Data de Aprovação": solicitation.approval && solicitation.approval.approvedAt ? new Date(solicitation.approval.approvedAt) : null,
            "Equipe": solicitation.businessUnit ? solicitation.businessUnit.name : null
        });
    })
    const companies = lodash.uniqBy(solicitations.map(x => x.company), 'id');
    const entries = await getChargeLinesIN(solicitations.map(x => x.id));
    const businessUnits = lodash.flatMap(await Promise.all(companies.map((company) => {
        return getAllEmployee(company.id, true, true);
    })))
    let levels = {};
    if (businessUnits && businessUnits.length > 0) {
        levels = lodash.chain(businessUnits.filter(x => x.level))
            .groupBy("level")
            .map((value, key) => ({ level: `Equipe Nível ${key}`, value: value }))
            .value()
    }
    const xlsxEntries = entries.map(x => {
        const solicitation = solicitations.find(sol => sol.id === x.solicitation);
        return {
            "Pedido": x.solicitation,
            ...(solicitation.company.enableCode ? { "Código": x.code } : {}),
            "Data de Aprovação": solicitation.approval && solicitation.approval.approvedAt ? new Date(solicitation.approval.approvedAt) : null,
            "CPF": x?.cpf,
            "Email": x?.email,
            "Nome": x?.name,
            "Segmentação": x?.benefit?.name,
            "Valor": x?.total || 0,
            ...lodash.reduce(levels, function(obj, param) {
                const equip = param.value.find(e => e.employees.find(u => u.id === x.user))
                obj[param.level] = equip ? equip.name : null
                return obj;
            }, {})
        }
    })
    exportXls().createAndSaveFile(
        ["Pedidos", "Participantes"],
        { "Pedidos": xlsxSolicitation, "Participantes": xlsxEntries },
        "Pedidos", "Pedidos");
}

export const downloadBankSlip = async (url) => {
    try {
        const { data } = await axios.get(url, { responseType: 'blob' });
        const urlPdf = window.URL.createObjectURL(data);
        window.open(urlPdf, "_blank");
    } catch (ex) {
        console.log(ex)
    }
}
